import { newLineToBr } from '../../../../../utils/common'
import {
  USER_INVITATION_FORM_FIELD_NAME_MESSAGE,
  USER_INVITATION_FORM_FIELD_NAME_SUBJECT,
  USER_INVITATION_FORM_FIELD_WITH_SMS,
} from '../../../../User'

export function getUserInvitationPayload(values) {
  const subject = values[USER_INVITATION_FORM_FIELD_NAME_SUBJECT]

  return {
    ...(subject ? { subject } : null),
    message: newLineToBr(values[USER_INVITATION_FORM_FIELD_NAME_MESSAGE]),
    send_sms: values[USER_INVITATION_FORM_FIELD_WITH_SMS],
  }
}
